import type { BlueprintAccessibilityElementModifier } from '@/grove-blueprints/generated-types'

import type { ResolvedModifiers } from './resolve-modifiers'

export function resolveAccessibilityElementModifier(
  modifier: BlueprintAccessibilityElementModifier,
) {
  const attributes: ResolvedModifiers['attributes'] = {}

  switch (modifier.children) {
    case 'combine': {
      attributes.role = 'group'
      break
    }
    default: {
      const unknownChildBehavior: never = modifier.children
      if (process.env.SDUI_BLUEPRINT_STRICT_MODE === 'true') {
        throw new Error(
          `Unsupported Blueprint accessibility child behavior: ${JSON.stringify(unknownChildBehavior)}`,
        )
      }
      break
    }
  }

  return attributes
}
